module.exports = __webpack_public_path__ + "static/media/YM31_3.818d811d.jpg";